<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>经销商授信管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <!--@click="exportExcel" -->
          <!-- <a class="aaaa" target="_blank" :href="'https://hsapi.sqmilk.com/exportExcel?data=' + this.multipleSelectionjson">
            <el-button size="mini" type="info">导出订单</el-button> 
          </a> -->
          <!-- <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出表格</el-button>
          </a> -->
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column label="经销商" prop="agencyName" width="130px"></el-table-column>
        <el-table-column label="业务员" prop="saleman" align="center" width="80px"> </el-table-column>
        <el-table-column label="授信账户" prop="creditMoney" align="center" width="80px"> </el-table-column>
        <el-table-column label="返点" prop="refund" align="center" width="80px"> </el-table-column>
        <el-table-column label="设备补贴" prop="subsidy" align="center" width="80px"> </el-table-column>

        <el-table-column label="授信状态" width="100px">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.sxstatus" @change="userStateChanged(scope.row,1)"> </el-switch>
          </template>
        </el-table-column>
       
        <el-table-column label="返点状态" width="100px">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.fdstatus" @change="userStateChanged(scope.row,2)"> </el-switch>
          </template>
        </el-table-column>
        
        <el-table-column label="设备补贴状态" width="100px">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.sbbtstatus" @change="userStateChanged(scope.row,3)"> </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="最后编辑人" prop="lastman_credit" align="center" width="100px"> </el-table-column>
        <el-table-column label="最后编辑时间" prop="lasttime_credit" align="center" width="100px"> </el-table-column>
        <el-table-column label="备注" prop="remark" align="center" width="100px"> </el-table-column>

        <el-table-column label="操作" width="250px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editOrder(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 修改用户的对话框 -->
    <el-dialog title="修改授信余额" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="130px">
        <el-form-item label="授信余额" prop="creditMoney">
          <el-input v-model="editForm.creditMoney"></el-input>
        </el-form-item>
        <el-form-item label="返点" prop="refund">
          <el-input v-model="editForm.refund"></el-input>
        </el-form-item>
        <el-form-item label="设备补贴" prop="subsidy">
          <el-input v-model="editForm.subsidy"></el-input>
        </el-form-item>
        <!-- <el-form-item label="备注1" prop="remark">
          <el-input v-model="editForm.remark"></el-input>
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.beizhu"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      exportUrl: 'javascript:return false;',
      queryInfo: {
        query: '',
        status: -1,
        type: 0,
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      // 审核状态0未审核，1审核通过2拒绝
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '未审核', id: 0 },
        { value: '审核通过', id: 1 },
        { value: '拒绝', id: 2 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '常温', id: 1 },
        { value: '低温', id: 2 },
      ],
      total: 0,
      orderlist: [],
      editDialogVisible: false,
      editForm: {
        creditMoney: null,
        refund: null,
        subsidy: null,
        beizhu: null,
      },
      editFormRules: {
        creditMoney: [
          { required: true, message: '请输入授信额度', trigger: 'blur' },
        ],
      },
      selectId: null,
      multipleSelectionjson: null,
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {
    searchOrder () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 编辑
    editOrder (data) {
      console.log(data);
      this.selectId = data.id;
      this.editForm.creditMoney = data.creditMoney
      this.editForm.refund = data.refund
      this.editForm.subsidy = data.subsidy
      this.editForm.beizhu = data.remark
      this.editDialogVisible = true
      // this.$router.push({ path: '/orders/detail', query: { id: id } })
    },

    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },

    // 确定
    async sure () {
      var phone = window.sessionStorage.getItem('phone')

      const { data: res } = await this.$http.post('admin/user/shouxin', {
        id: this.selectId,
        phone: phone,
        creditMoney: this.editForm.creditMoney,
        refund: this.editForm.refund,
        subsidy: this.editForm.subsidy,
        remark: this.editForm.beizhu,
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getOrderList()
      this.editDialogVisible = false
    },

    // 监听 switch 开关状态的改变
    async userStateChanged (userinfo,type) {
      console.log(userinfo,'hahah')
      var phone = window.sessionStorage.getItem('phone')
      const { data: res } = await this.$http.post('/admin/users/userStateChanged', {
        sxstatus: userinfo.sxstatus,
        fdstatus: userinfo.fdstatus?userinfo.fdstatus:'',
        sbbtstatus: userinfo.sbbtstatus?userinfo.sbbtstatus:'',
        id: userinfo.id,
        phone: phone,
        type:type
      })
      if (res.code !== 200) {
        userinfo.sxstate = !userinfo.sxstate
        return this.$message.error('更新状态失败！')
      }
      this.$message.success('更新状态成功！')
    },

    filterSelect () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://purchase.hsxsn.cn/jxsComsumeList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = "javascript:return false;"
      }
    },

    async getOrderList () {
      console.log(this.queryInfo)
      const { data: res } = await this.$http.get('admin/users/getAllUsersWithShouXin', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}
</style>
